import { useAuth } from '@/features/auth';

/**
 * Whether the current account runs the AI chat in simplified mode — approvals and the
 * work queue happen in INSIO, so the chat neither greets nor offers them.
 */
export function useAiChatSimplifiedMode(): boolean {
  const { user } = useAuth();
  return user?.aiChatSimplifiedMode === true;
}
